import { sortSection, chipsSection, checkboxGroupSection, switchSection } from '@/components/common/filterSections';

export default [
  sortSection({
    fieldKey: 'sortField',
    ascendingKey: 'sortAscending',
    options: [
      { value: 'status', label: 'Status' },
      { value: 'address', label: 'Street' },
      { value: 'dateIssued', label: 'Date Issued' },
      { value: 'dateApplied', label: 'Date Applied' },
      { value: 'dateExpires', label: 'Expiration Date' }
    ],
    directionLabel(field, asc) {
      switch (field) {
        case 'dateIssued':
        case 'dateApplied':
        case 'dateExpires':
          return asc ? 'Oldest → Newest' : 'Newest → Oldest';
        case 'address':
          return asc ? 'A → Z' : 'Z → A';
        default:
          return null;
      }
    }
  }),
  chipsSection({
    label: 'Status',
    key: 'status',
    multiple: true,
    options: (filter) => {
      const order = ['active', 'pending', 'inactive'];
      return filter.statusOptions
      .sort((s1, s2) => {
        const diff = order.indexOf(s1.type) - order.indexOf(s2.type);
        return diff || s1.label.localeCompare(s2.label);
      })
      .map(status => ({ value: status.code, label: status.label }))
    }
  }),
  chipsSection({
    label: 'License Type',
    key: 'licenseType',
    visible: (filter) => (filter.licenseTypeOptions || []).length > 0,
    options: (filter) => filter.licenseTypeOptions || []
  }),
  checkboxGroupSection({
    items: (filters) => (filters.customFields || []).map(field => ({
      key: field.id,
      label: field.label,
      options: field.options
    }))
  }),
  switchSection({ key: 'onlyShowMissingProperties', label: 'Unverified addresses only' })
];
